import { render, staticRenderFns } from "./storeData6.vue?vue&type=template&id=74e17452&"
import script from "./storeData6.vue?vue&type=script&lang=js&"
export * from "./storeData6.vue?vue&type=script&lang=js&"
import style0 from "./storeData6.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports